import React from 'react';
import Button from "b2b-ui-components-lib/lib/components/button";
import {stopBackgroundScrolling} from "../../../common/utils/app.utils";
import { PLAN_CONFIGURATION_MSG } from '../../../home/common/constants/message.constants';

const ChangePlanModal = (props) =>{
    const { showPopup, confirmChangePlan, closeChangePlanModal }=props;
    
    const closeCustomModal = () =>{
        stopBackgroundScrolling(false);
        closeChangePlanModal();
    }

    const confirmPlanChange = () => {
        stopBackgroundScrolling(false);
        confirmChangePlan()
    }
    
    return(
        <React.Fragment>
            <div className={`modal-custom ${showPopup ? "open" : ""}`}>
                <div className="modal_dialog contract_modal">
                    <div className="modal_content">
                        <div className="modal_body">
                            <div className="heading">{PLAN_CONFIGURATION_MSG.CHANGE_CONFIGURATION}</div>
                            <div className="next_step">
                                <Button onClick={closeCustomModal} variant="outlinebtn">Cancel</Button>
                                <Button onClick={confirmPlanChange} variant="activebtn">Yes</Button>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </React.Fragment>
    )
}

export default ChangePlanModal;
